import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BiciConfirmacionDatosComponent } from '../bici-confirmacion-datos/bici-confirmacion-datos.component';

@Component({
  selector: 'app-bici-sidebar-datos-personales',
  templateUrl: './bici-sidebar-datos-personales.component.html',
  styleUrls: ['./bici-sidebar-datos-personales.component.css']
})
export class BiciSidebarDatosPersonalesComponent implements OnInit {

  @Input()
  data: any = {};

  @Output()
  editClick: EventEmitter<any>;
  
  constructor(private modalService: NgbModal) {
    this.editClick = new EventEmitter();
   }

  ngOnInit() {
  }

  editarDatos(lead: any) {
    this.editClick.emit();
    const modalRef = this.modalService.open(BiciConfirmacionDatosComponent, { size: <any>'bici-editar-datos' });
    modalRef.componentInstance.lead = lead;
  }

}
